// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-title {
    background-color: #eee;
    padding: 1px;
}

#data-dialog h4 {
    color: #003561;
    margin: 10px;
    letter-spacing: 1px;
    font-weight: 400;
    font-family: 'Inter Regular';
}

.content-text {
    padding: 5px 10px;
    /* border-bottom: 1px#eee solid; */
    padding: 10px 10px;
}

.headmap h2 .mat-icon {
    vertical-align: middle;
    font-size: 20px;
    height: 20px;
    width: 20px;
}

.getbtn {
    margin-right: 10px;
}

h4.proxhead {
    margin: 10px 5px !important;
}

.custom-filter {
    padding: 0 !important;
}

.header-title .mat-icon {
    background-repeat: no-repeat;
    display: inline-block;
    fill: currentColor;
    height: 24px;
    width: 24px;
    margin-right: 16px;
    vertical-align: middle;
}

.width-100 {
    width: 100%;
}

::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
    padding: 0.5em 0 1em 0 !important;
}

.drawing-shape {
    margin-bottom: 15px;
}

.drawing-shape .mat-stroked-button {
    margin-right: 10px;
    min-width: 60px;
}

.drawing-shape .matstrockview img {
    width: 20px;
    height: 20px;
    position: relative;
    top: 3px;
}

.info-text {
    letter-spacing: 1px;
    margin-top: 0px;
    font-family: 'Inter Regular';
    text-align: center;
    color: rgb(216, 115, 115);
    font-size: 14px;
}

.align-center {
    text-align: center;
}

.example-tooltip-yellow {
    background: #ffcc00;
    color: #003561;
}

.label-text {
    font-family: 'Inter Regular';
}

.mb-15 {
    margin-bottom: 15px;
    letter-spacing: 1px;
}

.select-box {
    border-bottom: 1px #eee solid;
    padding-bottom: 15px;
}

.mat-radio-label-content {
    font-family: 'Inter Regular';
}



.pb-10 {
    padding-bottom: 10px;
}

/* start custom filter css */
.mlr-5 {
    margin: 0px 5px;
}

.width-32 {
    width: 32% !important;
}

.q-tree {
    padding-left: 0px !important;
}

.filter-text {
    color: #22547b;
    display: flex;
    justify-content: space-between;
    border: 1px lightgray solid;
    padding: 12px;
    border-radius: 16px;
    font-family: unset;
    letter-spacing: 1px;
    font-size: 15px;
    cursor: pointer;
}

.filter-text span {
    font-weight: 600;
}

/* end custom filter css */

@media (max-width: 768px) {
    .content-text {
        padding: 10px;
    }

    .drawing-shape .mat-stroked-button {
        min-width: 50px;
        margin: 0px 5px;
    }

    #data-dialog .mat-flat-button,
    #data-dialog .mat-raised-button {
        float: left;
        margin-bottom: 10px;
        margin-left: 10px;
    }

    .mat-radio-label {
        margin: 5px;
    }

    .mat-radio-label-content {
        font-size: 14px;
    }

    .mat-select-value {
        font-size: 12px;
    }

    .mat-form-field-appearance-outline .mat-form-field-label {
        top: 2.1em;
        font-size: 12px;
    }

    .mat-form-field-appearance-outline .mat-form-field-infix {
        padding: 0.5em 0 0.5em 0 !important;
    }

    .mat-form-field-infix {
        border-top: 0.2em solid transparent;
    }

    .mat-select-trigger {
        font-size: 12px;
    }

    .select-box ::ng-deep .mat-radio-outer-circle,
    .select-box ::ng-deep .mat-radio-inner-circle {
        height: 15px;
        width: 15px;
    }

    .proximity .mat-form-field-wrapper {
        padding-bottom: 0.5em !important;
    }
}

::ng-deep .my-custom-tooltipview {
    max-width: unset !important;
}

:host ::ng-deep .mat-progress-spinner circle,
.mat-spinner circle {
    stroke: #fff;
}

.getbtn {
    padding-right: 20px;
}

.matstrockview:active {
    background: #f1f8ff !important;
}

.active {
    /* background-color: #f6f9fc; */
    background-color: rgb(235, 231, 174);
}

.icdiv:last-child {
    margin-right: 0px;
}

.icdiv div {
    padding: 9px 5px 10px;
    background: #fff;
    min-width: 114px;
    border: 1px solid #003561;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 5px;
}

.morediv button {
    font-size: 10px;
    color: #003561;
    box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
    background: #fff !important;
    margin-left: 2px;
    padding: 0px 10px;
    line-height: 23px;
}

/* .mat-stepperdiv {
    height: calc(100vh - 115px);
    overflow: auto;
  } */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-thumb {
    background: #003561;
    border-radius: 10px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.mat-vertical-content {
    padding: 0 5px 0px 0px !important;
}

.headmap img {
    height: 16px;
    vertical-align: bottom;
    margin-right: 3px;
}

.icproxi {
    position: absolute;
    top: 10px;
    right: 8px;
}

.cloudexcelview .mat-icon,
.publishview {
    vertical-align: middle;
    /* position: relative; */
    height: 20px;
    width: 20px;
    font-size: 20px;
}

.p-15 {
    padding: 15px;
}

.width-45 {
    width: 45%;
}

.drawing-shape button {
    margin-right: 10px;
    border: 1px solid #003561;
    color: #003561 !important;
    border-radius: 26.5805px;
    line-height: 20px;
    min-width: 52px;
    height: 40px !important;
    background: none;
}

::ng-deep .q-connector {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    position: relative;

}

.active {
    background: #FFCC00 !important;
    border: 1px solid #FFCC00 !important;
    color: #003561;
    border-radius: 26.5805px;
}

.close-share {
    position: relative;
    right: 10px;
}

.resetview {
    position: relative;
    bottom: 1px;
}

.mat-p {
    position: relative;
    left: -4px;
}

.matOutline-div .matOutline {
    margin-bottom: 10px;
}

.width-23 {
    width: 23%;
}

.width-20 {
    width: 20%;
}

.width-25 {
    width: 25%;
}`, "",{"version":3,"sources":["webpack://./src/app/proximitry-analysis/proximity-analysis/proximity-analysis.component.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;;;AAIA;IACI,oBAAoB;AACxB;;AAEA,4BAA4B;AAC5B;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,0BAA0B;;AAE1B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,wCAAwC;IACxC,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;;KAGK;AACL;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":[".header-title {\n    background-color: #eee;\n    padding: 1px;\n}\n\n#data-dialog h4 {\n    color: #003561;\n    margin: 10px;\n    letter-spacing: 1px;\n    font-weight: 400;\n    font-family: 'Inter Regular';\n}\n\n.content-text {\n    padding: 5px 10px;\n    /* border-bottom: 1px#eee solid; */\n    padding: 10px 10px;\n}\n\n.headmap h2 .mat-icon {\n    vertical-align: middle;\n    font-size: 20px;\n    height: 20px;\n    width: 20px;\n}\n\n.getbtn {\n    margin-right: 10px;\n}\n\nh4.proxhead {\n    margin: 10px 5px !important;\n}\n\n.custom-filter {\n    padding: 0 !important;\n}\n\n.header-title .mat-icon {\n    background-repeat: no-repeat;\n    display: inline-block;\n    fill: currentColor;\n    height: 24px;\n    width: 24px;\n    margin-right: 16px;\n    vertical-align: middle;\n}\n\n.width-100 {\n    width: 100%;\n}\n\n::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n    padding: 0.5em 0 1em 0 !important;\n}\n\n.drawing-shape {\n    margin-bottom: 15px;\n}\n\n.drawing-shape .mat-stroked-button {\n    margin-right: 10px;\n    min-width: 60px;\n}\n\n.drawing-shape .matstrockview img {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    top: 3px;\n}\n\n.info-text {\n    letter-spacing: 1px;\n    margin-top: 0px;\n    font-family: 'Inter Regular';\n    text-align: center;\n    color: rgb(216, 115, 115);\n    font-size: 14px;\n}\n\n.align-center {\n    text-align: center;\n}\n\n.example-tooltip-yellow {\n    background: #ffcc00;\n    color: #003561;\n}\n\n.label-text {\n    font-family: 'Inter Regular';\n}\n\n.mb-15 {\n    margin-bottom: 15px;\n    letter-spacing: 1px;\n}\n\n.select-box {\n    border-bottom: 1px #eee solid;\n    padding-bottom: 15px;\n}\n\n.mat-radio-label-content {\n    font-family: 'Inter Regular';\n}\n\n\n\n.pb-10 {\n    padding-bottom: 10px;\n}\n\n/* start custom filter css */\n.mlr-5 {\n    margin: 0px 5px;\n}\n\n.width-32 {\n    width: 32% !important;\n}\n\n.q-tree {\n    padding-left: 0px !important;\n}\n\n.filter-text {\n    color: #22547b;\n    display: flex;\n    justify-content: space-between;\n    border: 1px lightgray solid;\n    padding: 12px;\n    border-radius: 16px;\n    font-family: unset;\n    letter-spacing: 1px;\n    font-size: 15px;\n    cursor: pointer;\n}\n\n.filter-text span {\n    font-weight: 600;\n}\n\n/* end custom filter css */\n\n@media (max-width: 768px) {\n    .content-text {\n        padding: 10px;\n    }\n\n    .drawing-shape .mat-stroked-button {\n        min-width: 50px;\n        margin: 0px 5px;\n    }\n\n    #data-dialog .mat-flat-button,\n    #data-dialog .mat-raised-button {\n        float: left;\n        margin-bottom: 10px;\n        margin-left: 10px;\n    }\n\n    .mat-radio-label {\n        margin: 5px;\n    }\n\n    .mat-radio-label-content {\n        font-size: 14px;\n    }\n\n    .mat-select-value {\n        font-size: 12px;\n    }\n\n    .mat-form-field-appearance-outline .mat-form-field-label {\n        top: 2.1em;\n        font-size: 12px;\n    }\n\n    .mat-form-field-appearance-outline .mat-form-field-infix {\n        padding: 0.5em 0 0.5em 0 !important;\n    }\n\n    .mat-form-field-infix {\n        border-top: 0.2em solid transparent;\n    }\n\n    .mat-select-trigger {\n        font-size: 12px;\n    }\n\n    .select-box ::ng-deep .mat-radio-outer-circle,\n    .select-box ::ng-deep .mat-radio-inner-circle {\n        height: 15px;\n        width: 15px;\n    }\n\n    .proximity .mat-form-field-wrapper {\n        padding-bottom: 0.5em !important;\n    }\n}\n\n::ng-deep .my-custom-tooltipview {\n    max-width: unset !important;\n}\n\n:host ::ng-deep .mat-progress-spinner circle,\n.mat-spinner circle {\n    stroke: #fff;\n}\n\n.getbtn {\n    padding-right: 20px;\n}\n\n.matstrockview:active {\n    background: #f1f8ff !important;\n}\n\n.active {\n    /* background-color: #f6f9fc; */\n    background-color: rgb(235, 231, 174);\n}\n\n.icdiv:last-child {\n    margin-right: 0px;\n}\n\n.icdiv div {\n    padding: 9px 5px 10px;\n    background: #fff;\n    min-width: 114px;\n    border: 1px solid #003561;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 5px;\n}\n\n.morediv button {\n    font-size: 10px;\n    color: #003561;\n    box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;\n    background: #fff !important;\n    margin-left: 2px;\n    padding: 0px 10px;\n    line-height: 23px;\n}\n\n/* .mat-stepperdiv {\n    height: calc(100vh - 115px);\n    overflow: auto;\n  } */\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #003561;\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.mat-vertical-content {\n    padding: 0 5px 0px 0px !important;\n}\n\n.headmap img {\n    height: 16px;\n    vertical-align: bottom;\n    margin-right: 3px;\n}\n\n.icproxi {\n    position: absolute;\n    top: 10px;\n    right: 8px;\n}\n\n.cloudexcelview .mat-icon,\n.publishview {\n    vertical-align: middle;\n    /* position: relative; */\n    height: 20px;\n    width: 20px;\n    font-size: 20px;\n}\n\n.p-15 {\n    padding: 15px;\n}\n\n.width-45 {\n    width: 45%;\n}\n\n.drawing-shape button {\n    margin-right: 10px;\n    border: 1px solid #003561;\n    color: #003561 !important;\n    border-radius: 26.5805px;\n    line-height: 20px;\n    min-width: 52px;\n    height: 40px !important;\n    background: none;\n}\n\n::ng-deep .q-connector {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    position: relative;\n\n}\n\n.active {\n    background: #FFCC00 !important;\n    border: 1px solid #FFCC00 !important;\n    color: #003561;\n    border-radius: 26.5805px;\n}\n\n.close-share {\n    position: relative;\n    right: 10px;\n}\n\n.resetview {\n    position: relative;\n    bottom: 1px;\n}\n\n.mat-p {\n    position: relative;\n    left: -4px;\n}\n\n.matOutline-div .matOutline {\n    margin-bottom: 10px;\n}\n\n.width-23 {\n    width: 23%;\n}\n\n.width-20 {\n    width: 20%;\n}\n\n.width-25 {\n    width: 25%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
